import React from 'react'

import { CircularProgress } from '@mui/material'

const sizeMap: Record<string, number> = {
  xs: 16,
  sm: 24,
  md: 40,
  lg: 56,
}

export const Loader = ({ size = 'md' }: { size?: 'xs' | 'sm' | 'md' | 'lg' }) => (
  <CircularProgress size={sizeMap[size] ?? sizeMap.md} color="inherit" />
)
